import styled from 'styled-components'

import { InfoIcon } from '@blade/ui-kit'

import { CrossCircleIcon } from '../icons'

import type { Intent } from '@blade/ui-kit'
import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

export type AlertProps = {
  intent: Intent
} & ChildrenProps &
  ClassNameProps

export const Alert: React.FC<AlertProps> = ({
  intent,
  children,
  className,
}) => {
  const renderIcon = () => {
    if (intent === 'error') {
      return <CrossCircleIcon size={32} />
    }
    return <InfoIcon size={32} />
  }

  return (
    <Root $intent={intent} className={className}>
      <HackIconWrapper>{renderIcon()}</HackIconWrapper>
      <Text>{children}</Text>
    </Root>
  )
}

const Text = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const HackIconWrapper = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Root = styled.div<{ $intent: Intent }>`
  padding-inline: 6px 12px;
  padding-block: 6px;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 12px;

  border-radius: 8px;
  background: ${({ $intent }) => {
    if ($intent === 'error') {
      return 'var(--errorA-3)'
    }
    if ($intent === 'warning') {
      return 'var(--warningA-3)'
    }
  }};
  color: ${({ $intent }) => {
    if ($intent === 'error') {
      return 'var(--error-9)'
    }
    if ($intent === 'warning') {
      return 'var(--warning-9)'
    }
  }};
`
